import Guid from "~/helpers/guid";
import Form from '../form';
import {FormDetailStepModelType} from "../../enums/formDetailStepModelType";
import FormDetailStep from "./formDetailStep";
import FormDetailInstruction from "./formDetailInstruction";
import FormDetailProcess from "./formDetailProcess";

export default class FormDetailStepFactory {
  static create(form: Form, stepType: FormDetailStepModelType): FormDetailStep {
    let step: FormDetailStep = null;

    switch (stepType) {
      case FormDetailStepModelType.instruction:
        step = new FormDetailInstruction(form);
        break;
      case FormDetailStepModelType.process:
        step = new FormDetailProcess(form);
        break;
      default:
        break;
    }

    step.defineProperty('client_id', Guid.create());
    step.defineProperty('title', '');
    step.defineProperty('description', '');
    step.defineProperty('sort_order', form.nextSortOrderFor(step.rootName));
    step.parent = form;
    step.rootModel = form;
    return step;
  }
}